module.exports = __webpack_public_path__ + "static/media/marketplace.56249d86.svg";